export default {
  pt:{
    conhecerEquipa: "Conhecer equipa",
    ano: "Ano",
    calendarios: "Calendários",
    curso: "Curso",
    data: "Data",
    designacao: "Designação",
    documentos: "Documentos",
    noticia: "Notícia",
    resultados: "Resultados",
    semdoc: "Sem documentos para apresentar",
    semnoticias: "Sem eventos para apresentar",
    semresultados: "Sem resultados para apresentar",
    semcursos: "Sem cursos para apresentar",
    semcalendarios: "Sem calendários para apresentar",
    semprovas: "Não foram encontradas provas",
    vermais: "Ver Mais",
    provas: "Provas",
    provaaval: "Prova de Avaliação",
    pesquisarDocs: "Pesquisar Documentos",
    pesquisarresultados: "Pesquisar Resultados",
    ligacoeslist:{
        ligacoes: "Ligações",
        titulo: "Título/Descrição",
        website: "Website"
    },
    menu:{
      apresentacao: "Apresentação",
      noticias: "Notícias",
      calendarios: "Calendários",
      provas: "Candidaturas às Provas",
      cursos: "Cursos",
      paccs: "PACCS - Programa e Enunciados",
      resultados: "Resultados",
      documentacao: "Documentação",
      faq: "Perguntas Frequentes",
      composicao: "Composição",
      eventos: "Notícias e Eventos",
      ligacoes: "Ligações",
      relatorios: "Relatórios e outros documentos"
    },
    apesquisar: "A pesquisar",
    textoapresentacao:`<p>A Reitoria manifestou o interesse institucional em criar uma Comissão de Direitos, Liberdades e
    Garantias, expressa no plano de atividades de 2021 da Universidade da Madeira (UMa), que prevê a
    prossecução dos princípios da igualdade na instituição, no âmbito de uma visão global, onde se
    inclui, nomeadamente, a não discriminação de género.</p>
<p>Sendo a Universidade um veículo privilegiado de formação e criação de saber, com capacidade de
    influenciar e transformar não só os recursos humanos que a integram, mas também o meio social em
    que se insere, e estando a UMa bem implantada na Região com inúmeras ligações com a sociedade local,
    consideramos que existem as condições fundamentais para que esta missão possa vir a ser
    bem-sucedida.</p>
<p>Com a consciência de que qualquer alteração ao nível da educação e da mudança de mentalidades é um
    processo com um ciclo longo e que não passa, fundamentalmente, pela criação ou imposição de regras,
    mas sim por uma mudança de paradigma que se pretende que opere transformações profundas e
    duradouras nos indivíduos, encaramos este projeto como um processo a médio longo prazo, que será
    adaptado e ajustado ao longo da sua implementação.</p>
<p>Uma das funções desta Comissão será a realização do Plano para a igualdade de género, definindo um
    rumo para abordar esta problemática e agregando também algumas das iniciativas pontuais que já têm
    lugar na Academia.</p>
<p>A constituição da equipa de trabalho terá em consideração a representatividade dos diferentes
    intervenientes da Academia e também as diversas realidades que as áreas do conhecimento espelham.
    A coordenação da equipa será assumida por um docente designado pelo Reitor e será constituída por
    um representante do corpo docente de cada Faculdade ou Escola, indicado pelo respetivo conselho
    científico ou técnico-científico; um representante dos funcionários, indicado pelo Reitor; e um
    representante dos alunos, a indicado pela Associação Académica. O Reitor poderá ainda nomear
    algumas personalidades externas para esta comissão.</p>
<p>Após a constituição da equipa, terão início as várias etapas previstas para elaboração do Plano.</p>
<h5>Linhas orientadoras para o Plano para a Igualdade de Género</h5>
<p>Para levar a cabo este projeto, estão previstas as seguintes fases: i) elaboração de um diagnóstico
    ao nível da instituição; ii) elaboração de um plano de ação e operacionalização das iniciativas e
    medidas concebidas; iii) avaliação e controlo das ações implementadas.</p>
<p>i) Diagnóstico ao nível da instituição</p>
<p>Nesta fase, pretende-se identificar as principais lacunas existentes neste género de instituições
    (universidades), já referenciadas na bibliografia sobre o assunto, e compreender qual o estado da
    arte relativamente a esta temática.</p>
<p>Este enquadramento irá permitir à comissão compreender quais os dados que serão úteis recolher e as
    reformulações que é necessário introduzir nos serviços para os poder obter num formato que seja
    compatível com os objetivos definidos.</p>
<p>De uma forma muito sucinta, o que se pretende é que haja uma recolha de dados que nos permita fazer
    uma análise de género, tanto numa perspetiva horizontal como vertical da instituição, identificando
    os vários intervenientes da Academia (funcionários docentes, funcionários não docentes, discentes),
    de modo a reconhecer possíveis disfunções, mas também as causas destas. Para além desta vertente
    mais quantitativa, há também que ter em consideração a identificação de possíveis áreas de formação
    que sejam consideradas importantes para a Instituição e que possam ser úteis na consciencialização
    das pessoas para este tipo de temática.</p>
<p>ii) Plano de Ação e Operacionalização das medidas concebidas</p>
<p>Naturalmente que o plano de ação a traçar e implementar será elaborado em função do diagnóstico a
    realizar. No entanto, é já possível delinear algumas áreas de intervenção, não obstante termos
    consciência de que estas poderão sofrer ajustes ao longo deste processo.</p>
<p>De uma forma geral, consideramos que o delineamento deste plano de ação deverá passar pela
    sensibilização para este tipo de problemáticas, pelo fornecimento de instrumentos de atuação e pela
    aprendizagem da sua aplicação. Estas diferentes vertentes deverão abranger a legislação em vigor,
    as práticas institucionais, a formação e a investigação.</p>
<p>Algumas das áreas de intervenção, sem prejuízo de se poderem incluir outras, em função das opções
    tomadas pela Comissão, são: o apoio à conciliação da vida familiar e profissional de estudantes, e
    de pessoal docente e não docente; o aumento do grau de compromisso da Instituição com os princípios
    da igualdade de género, procurando atingir uma representação equilibrada a diferentes níveis;
    assim como, a sensibilização para a violência e assédio associados ao género.</p>
<p>iii) Avaliação e controlo das ações implementadas</p>
<p>A compreensão da eficácia das ações delineadas passa naturalmente pela avaliação dos seus efeitos,
    através de indicadores que nos permitam compreender não só os sucessos obtidos, mas também as
    falhas e as estratégias a considerar para as poder colmatar.</p>
<p>Esta avaliação será individualizada para algumas das ações a implementar, mas também comtemplará
    uma avaliação geral, realizada em ciclos anuais, de modo a permitir ajustar grandes linhas de
    intervenção e adaptar o plano de acordo com as necessidades que forem identificadas.</p>
<p>O reitor,<br>
    Sílvio Fernandes</p>
<a class="showmore" href="<?php echo get_stylesheet_directory_uri(); ?>\docs\Proposta para a Constituição da Comissão de Direitos, Liberdades e Garantias e linhas Orientadoras Plano Para a Igualdade de Género.pdf">
    Consultar proposta para a constituição da Comissão de Direitos, Liberdades e Garantias e linhas orientadoras para o Plano para a Igualdade de Género
</a>`,
  },
  en: {
    conhecerEquipa: "Get to know the team",
    ano: "Year",
    calendarios: "Calendários",
    curso: "Course",
    data: "Date",
    designacao: "Designação",
    documentos: "Documents",
    noticia: "News",
    resultados: "Results",
    semdoc: "Sem documentos para apresentar",
    semnoticias: "Sem notícias para apresentar",
    semresultados: "Sem resultados para apresentar",
    semcursos: "Sem cursos para apresentar",
    semcalendarios: "Sem calendários para apresentar",
    semprovas: "Não foram encontradas provas",
    vermais: "See More",
    provas: "Provas",
    provaaval: "Prova de Avaliação",
    pesquisarDocs: "Search Documents",
    pesquisarresultados: "Pesquisar Resultados",
    menu:{
      apresentacao: "Introduction",
      noticias: "News",
      calendarios: "Calendars",
      provas: "Candidaturas às Provas",
      cursos: "Courses",
      paccs: "PACCS - Programa e Enunciados",
      resultados: "Results",
      documentacao: "Documentation",
      faq: "Frequently Asked Questions",
      composicao: "Composição",
      eventos: "News and Events",
      ligacoes: "Ligações",
      relatorios: "Relatórios e outros documentos"
    },
    ligacoeslist:{
        ligacoes: "Ligações",
        titulo: "Título/Descrição",
        website: "Website"
    },
    apesquisar: "Searching",
    textoapresentacao:`<p>A Reitoria manifestou o interesse institucional em criar uma Comissão de Direitos, Liberdades e
    Garantias, expressa no plano de atividades de 2021 da Universidade da Madeira (UMa), que prevê a
    prossecução dos princípios da igualdade na instituição, no âmbito de uma visão global, onde se
    inclui, nomeadamente, a não discriminação de género.</p>
<p>Sendo a Universidade um veículo privilegiado de formação e criação de saber, com capacidade de
    influenciar e transformar não só os recursos humanos que a integram, mas também o meio social em
    que se insere, e estando a UMa bem implantada na Região com inúmeras ligações com a sociedade local,
    consideramos que existem as condições fundamentais para que esta missão possa vir a ser
    bem-sucedida.</p>
<p>Com a consciência de que qualquer alteração ao nível da educação e da mudança de mentalidades é um
    processo com um ciclo longo e que não passa, fundamentalmente, pela criação ou imposição de regras,
    mas sim por uma mudança de paradigma que se pretende que opere transformações profundas e
    duradouras nos indivíduos, encaramos este projeto como um processo a médio longo prazo, que será
    adaptado e ajustado ao longo da sua implementação.</p>
<p>Uma das funções desta Comissão será a realização do Plano para a igualdade de género, definindo um
    rumo para abordar esta problemática e agregando também algumas das iniciativas pontuais que já têm
    lugar na Academia.</p>
<p>A constituição da equipa de trabalho terá em consideração a representatividade dos diferentes
    intervenientes da Academia e também as diversas realidades que as áreas do conhecimento espelham.
    A coordenação da equipa será assumida por um docente designado pelo Reitor e será constituída por
    um representante do corpo docente de cada Faculdade ou Escola, indicado pelo respetivo conselho
    científico ou técnico-científico; um representante dos funcionários, indicado pelo Reitor; e um
    representante dos alunos, a indicado pela Associação Académica. O Reitor poderá ainda nomear
    algumas personalidades externas para esta comissão.</p>
<p>Após a constituição da equipa, terão início as várias etapas previstas para elaboração do Plano.</p>
<h5>Linhas orientadoras para o Plano para a Igualdade de Género</h5>
<p>Para levar a cabo este projeto, estão previstas as seguintes fases: i) elaboração de um diagnóstico
    ao nível da instituição; ii) elaboração de um plano de ação e operacionalização das iniciativas e
    medidas concebidas; iii) avaliação e controlo das ações implementadas.</p>
<p>i) Diagnóstico ao nível da instituição</p>
<p>Nesta fase, pretende-se identificar as principais lacunas existentes neste género de instituições
    (universidades), já referenciadas na bibliografia sobre o assunto, e compreender qual o estado da
    arte relativamente a esta temática.</p>
<p>Este enquadramento irá permitir à comissão compreender quais os dados que serão úteis recolher e as
    reformulações que é necessário introduzir nos serviços para os poder obter num formato que seja
    compatível com os objetivos definidos.</p>
<p>De uma forma muito sucinta, o que se pretende é que haja uma recolha de dados que nos permita fazer
    uma análise de género, tanto numa perspetiva horizontal como vertical da instituição, identificando
    os vários intervenientes da Academia (funcionários docentes, funcionários não docentes, discentes),
    de modo a reconhecer possíveis disfunções, mas também as causas destas. Para além desta vertente
    mais quantitativa, há também que ter em consideração a identificação de possíveis áreas de formação
    que sejam consideradas importantes para a Instituição e que possam ser úteis na consciencialização
    das pessoas para este tipo de temática.</p>
<p>ii) Plano de Ação e Operacionalização das medidas concebidas</p>
<p>Naturalmente que o plano de ação a traçar e implementar será elaborado em função do diagnóstico a
    realizar. No entanto, é já possível delinear algumas áreas de intervenção, não obstante termos
    consciência de que estas poderão sofrer ajustes ao longo deste processo.</p>
<p>De uma forma geral, consideramos que o delineamento deste plano de ação deverá passar pela
    sensibilização para este tipo de problemáticas, pelo fornecimento de instrumentos de atuação e pela
    aprendizagem da sua aplicação. Estas diferentes vertentes deverão abranger a legislação em vigor,
    as práticas institucionais, a formação e a investigação.</p>
<p>Algumas das áreas de intervenção, sem prejuízo de se poderem incluir outras, em função das opções
    tomadas pela Comissão, são: o apoio à conciliação da vida familiar e profissional de estudantes, e
    de pessoal docente e não docente; o aumento do grau de compromisso da Instituição com os princípios
    da igualdade de género, procurando atingir uma representação equilibrada a diferentes níveis;
    assim como, a sensibilização para a violência e assédio associados ao género.</p>
<p>iii) Avaliação e controlo das ações implementadas</p>
<p>A compreensão da eficácia das ações delineadas passa naturalmente pela avaliação dos seus efeitos,
    através de indicadores que nos permitam compreender não só os sucessos obtidos, mas também as
    falhas e as estratégias a considerar para as poder colmatar.</p>
<p>Esta avaliação será individualizada para algumas das ações a implementar, mas também comtemplará
    uma avaliação geral, realizada em ciclos anuais, de modo a permitir ajustar grandes linhas de
    intervenção e adaptar o plano de acordo com as necessidades que forem identificadas.</p>
<p>O reitor,<br>
    Sílvio Fernandes</p>
<a class="showmore" href="<?php echo get_stylesheet_directory_uri(); ?>\docs\Proposta para a Constituição da Comissão de Direitos, Liberdades e Garantias e linhas Orientadoras Plano Para a Igualdade de Género.pdf">
    Consultar proposta para a constituição da Comissão de Direitos, Liberdades e Garantias e linhas orientadoras para o Plano para a Igualdade de Género
</a>`,
  }
}